import axios from 'axios';
import { auth } from './firebaseConfig';

// API基础配置
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://accord-80188461915.us-east4.run.app/api/v1'
    : 'http://localhost:3000/api/v1');

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 200000, // 200秒超时（AI生成需要更长时间，留出缓冲）
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加认证token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      // 优先使用 Firebase ID token
      if (auth.currentUser) {
        const idToken = await auth.currentUser.getIdToken();
        config.headers.Authorization = `Bearer ${idToken}`;
      } else {
        // 回退到 localStorage 中的 token（兼容旧系统）
        const token = localStorage.getItem('authToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.log('获取认证token失败:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Token过期，清除本地存储
      localStorage.removeItem('authToken');
      localStorage.removeItem('userInfo');
      // 不再自动重定向，让组件自己决定如何处理未认证状态
    }
    return Promise.reject(error);
  }
);

export default apiClient;
